/** @format */

import * as React from 'react';
import { IconBasicBeachLine } from '../components/icons/IconBasicBeachLine';
import { IconBasicChildrenServices } from '../components/icons/IconBasicChildrenServices';
import { IconBasicHealth } from '../components/icons/IconBasicHealth';
import { IconBasicInternet } from '../components/icons/IconBasicInternet';
import { IconBasicRoomsAmenities } from '../components/icons/IconBasicRoomsAmenities';
import { IconBasicTransport } from '../components/icons/IconBasicTransport';
import { HotelBasicFacilityGroups } from '../hotel-page/models/hotel-info';
import { IconBasicCheckInOutTimes } from '../components/icons/IconBasicCheckInOutTimes';



export const getBasicIconGroup = (type: HotelBasicFacilityGroups) => {
    switch (type) {
        case HotelBasicFacilityGroups.BeachLine:
            return <IconBasicBeachLine />;
        case HotelBasicFacilityGroups.ChildrenServices:
            return <IconBasicChildrenServices />;
        case HotelBasicFacilityGroups.Health:
            return <IconBasicHealth />;
        case HotelBasicFacilityGroups.Internet:
            return <IconBasicInternet />;
        case HotelBasicFacilityGroups.RoomsAmenities:
            return <IconBasicRoomsAmenities />;
        case HotelBasicFacilityGroups.Transportation:
            return <IconBasicTransport />;
        case HotelBasicFacilityGroups.CheckInOutIimes:
            return <IconBasicCheckInOutTimes />;
        default:
            return <></>;
    }
};
